import { render, staticRenderFns } from "./TeamsList.vue?vue&type=template&id=1bd5a7be&scoped=true&"
import script from "./TeamsList.vue?vue&type=script&lang=js&"
export * from "./TeamsList.vue?vue&type=script&lang=js&"
import style0 from "./TeamsList.vue?vue&type=style&index=0&id=1bd5a7be&lang=scss&scoped=true&"
import style1 from "./TeamsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd5a7be",
  null
  
)

export default component.exports